module.exports = __webpack_public_path__ + "img/purple-2-squiggly-striped.f0948a07.svg";